// Debugging confirmation
console.log('✅ build-manager-utils.js loaded successfully!');

// Base URL from configuration
import { APP_CONFIG } from './config.js';
import { appState } from './state.js'; // ✅ PERSISTENT_KEYS are Set of keys that should persist across sessions

//const baseURL = APP_CONFIG.BASE_URL;
//const baseURL = appState.BASE_URL; // Use the base URL for images

/**
 * Detects if the current environment is Node.js
 * @returns {boolean} - True if running in Node.js, false otherwise
 */
function isNodeEnvironment() {
  return typeof process !== 'undefined' && process.versions && process.versions.node;
}

/**
 * Logs environment detection for debugging
 */
function logEnvironmentCheck() {
  const isNode = isNodeEnvironment();
  console.log(`🌍 Environment Check - Is Node: ${isNode}`);

  if (isNode) {
    console.log(`✅ Node.js version detected: ${process.versions.node}`);
  } else {
    console.log('🌐 Browser environment detected.');
  }
}

// Log environment status
logEnvironmentCheck();

// Fetches content from a file or URL based on the environment, filePath - The path to the file or URL, {string} - The loaded content

async function fetchContent(filePath) {
  try {
    if (isNodeEnvironment()) {
      const fs = await import('fs/promises');
      console.log('🔄 Attempting to load from file system:', filePath);
      return await fs.readFile(filePath, 'utf8');
    } else {
      console.log('🌐 Attempting to load from URL:', filePath);
      const response = await fetch(filePath);
      if (!response.ok) throw new Error(`Failed to load content from: ${filePath}`);
      return await response.text();
    }
  } catch (error) {
    console.error('❌ Error fetching content:', error);
    return '';
  }
}

/**
 * Get content from the specified page folder path
 * @param {string} folderPath - The folder path to fetch
 * @returns {string} - The content from the specified folder
 */
async function getPageContent(folderPath) {
  const filePath = isNodeEnvironment()
    ? `${process.cwd()}/src/${folderPath}.html`
    : `${appState.BASE_URL}/${folderPath}.html`;

  return await fetchContent(filePath);
}

/**
 * Get master page content from the specified layout path
 * @param {string} masterLayoutPath - The layout path to fetch
 * @returns {string} - The content from the specified layout
 */
async function getMasterPageContent(masterLayoutPath) {
  const filePath = isNodeEnvironment()
    ? `${process.cwd()}/src/${masterLayoutPath}.html`
    : `${appState.BASE_URL}/${masterLayoutPath}.html`;

  return await fetchContent(filePath);
}

function resolvePageFolderPath(pageTranslateKey) {
  const pageMapping = {
    keyColors: 'helpers/colors',
    keyHome: 'pages/home',
    keyCategories: 'pages/catalog-pages/categories',
    keyProducts: 'pages/catalog-pages/products',
    keyProduct: 'pages/catalog-pages/product',
    keyListing: 'pages/catalog-pages/listing',
    keyCart: 'pages/cart',
    keyCheckout: 'pages/checkout',
    keyWishlist: 'pages/wishlist',
    keyOrders: 'pages/orders',
    keyOrder: 'pages/order',
    keyAccount: 'pages/account',
    keyAboutUs: 'pages/about-us',
    keyContactUs: 'pages/contact-us',
    keyLogin: 'pages/auth-pages/login',
    keyRegister: 'pages/auth-pages/register',
    keyForgotPassword: 'pages/auth-pages/forgot-password',
    key404: 'pages/404',
  };

  return pageMapping[pageTranslateKey] || 'pages/404';
}

///**
// * Gets the content of a page based on the page key
// * @param {string} pageTranslateKey - The page translation key
// * @returns {string} - The page content
// */
//export async function getRegularPageLayoutContentByPageName(pageTranslateKey) {
//    console.log(`🔄 Fetching content for page: ${pageTranslateKey}`);
//    const folderPath = resolvePageFolderPath(pageTranslateKey);
//    return await getPageContent(folderPath);
//}

///**
// * Gets the master page layout content by page name
// * @param {string} pageTranslateKey - The page translation key
// * @returns {string} - The master page content
// */
//export async function getMasterPageLayoutContentByPageName(pageTranslateKey) {
//    console.log(`🔄 Fetching master page content for: ${pageTranslateKey}`);
//    const folderPath = resolvePageFolderPath(pageTranslateKey);
//    return await getMasterPageContent(folderPath);
//}

/**
 * Get the master layout content from the specified folder path
 * @param {string} masterPageContentFolderPath - The folder path for the master layout
 * @returns {string} - The master layout content
 */
export async function getMasterLayoutContentByFolderPath(masterPageContentFolderPath) {
  console.log(`🔄 Loading master layout from folder: ${masterPageContentFolderPath}`);
  return await getMasterPageContent(masterPageContentFolderPath);
}

/**
 * Get the regular page layout content from the specified folder path
 * @param {string} pageContentFolderPath - The folder path for the page layout
 * @returns {string} - The regular page layout content
 */
export async function getRegularPageLayoutContentByFolderPath(pageContentFolderPath) {
  console.log(`🔄 Loading page layout from folder: ${pageContentFolderPath}`);
  return await getPageContent(pageContentFolderPath);
}

export async function ensureDynamicComponentLoaded(tagName, modulePath) {
  // Check if the custom element is already defined
  if (!customElements.get(tagName)) {
    try {
      console.log(
        `🌐 Attempting to do Dynamic component load: ${tagName} :  From modulePath : ${modulePath}`
      );

      //const module = await import(`${modulePath}`);

      const module = await import(`../builders-components/${modulePath}`);

      console.log(`✅ Dynamic component loaded: ${tagName}`);
      return module;
    } catch (err) {
      console.error(`❌ Failed to Dynamic component load ${tagName}:`, err);
    }
  } else {
    console.log(`✅ Dynamic component load already registered: ${tagName}`);
  }
}

//export async function ensureDynamicComponentLoaded(tagName, modulePath) {
//    // Check if the custom element is already defined
//    if (!customElements.get(tagName)) {
//        try {
//            console.log(`🌐 Attempting to load dynamic component: ${tagName}`);
//            const module = await import(`../components/${modulePath}`);
//            console.log(`✅ Dynamic component loaded: ${tagName}`);
//            return module;
//        } catch (err) {
//            console.error(`❌ Failed to load dynamic component ${tagName}:`, err);
//        }
//    } else {
//        console.log(`✅ Dynamic component already registered: ${tagName}`);
//    }
//}
